export default {
  baseUrl: '',
  accessToken: localStorage.getItem("RobohomeDataAccessToken") || null,
  home: localStorage.getItem("RobohomeAdminActiveHome") || null,
  editMode: false,
  requestCancellers: {},
  scrolled: 0,
  storeActiveGroup: localStorage.getItem("RobohomeAdminActiveGroup") || null,
  timezone: localStorage.getItem("RobohomeAdminTZ") || null,
  themeColor: localStorage.getItem("RobohomeTheme") || null,
};
